module.exports = __webpack_public_path__ + "static/media/sansa.0a08fa28.jpg";